import React from 'react';
import { Box, Typography, Card, CardContent, Grid } from '@mui/material';
import VerifiedIcon from '@mui/icons-material/Verified';
import SecurityIcon from '@mui/icons-material/Security';
import { useTranslation } from 'react-i18next';

/**
 * FrameworkBadges - Grid of framework badges for public display
 * @param {Array} badges - Array of framework badge objects
 */
export const FrameworkBadges = ({ badges = [] }) => {
  const { t } = useTranslation('transparency');
  if (!badges || badges.length === 0) {
    return (
      <Typography variant="body2" color="text.secondary">
        {t('public.emptyFrameworks')}
      </Typography>
    );
  }

  return (
    <Grid container spacing={2}>
      {badges.map((badge, index) => (
        <Grid item xs={12} sm={6} md={4} key={badge.frameworkId || index}>
          <Card
            elevation={0}
            sx={{
              border: '1px solid #e0e0e0',
              borderRadius: 2,
              height: '100%',
              textAlign: 'center',
              transition: 'transform 0.2s, box-shadow 0.2s',
              '&:hover': {
                transform: 'translateY(-2px)',
                boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
              },
            }}
          >
            <CardContent>
              <Box sx={{ display: 'flex', justifyContent: 'center', mb: 1 }}>
                {badge.isCompliant ? (
                  <VerifiedIcon sx={{ fontSize: 36, color: '#4caf50' }} />
                ) : (
                  <SecurityIcon sx={{ fontSize: 36, color: '#1976d2' }} />
                )}
              </Box>
              <Typography variant="subtitle1" fontWeight={600}>
                {badge.name}
              </Typography>
              {badge.maturityLabel && (
                <Typography variant="caption" color="text.secondary">
                  {badge.maturityLabel}
                </Typography>
              )}
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
};
